export default function PaymentCancelPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <h1 className="text-xl font-bold text-slate-900">Payment cancelled</h1>
        <p className="mt-2 text-sm text-slate-600">
          No payment was taken. You can close this page or use the payment link again if you still need to pay.
        </p>
      </div>
    </div>
  );
}
